import { SVGProps } from '../types';

const BitcoinCashIcon = (props: SVGProps) => (
  <svg
    width="46"
    height="32"
    viewBox="0 0 46 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      fill="white"
    />
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      stroke="#DEDBD4"
    />
    <path
      d="M17.4618 6.2614C22.6876 3.31144 29.3159 5.15635 32.2661 10.3824C35.2162 15.6085 33.3709 22.2367 28.145 25.1867C22.9193 28.1363 16.2917 26.2911 13.3416 21.0652C10.3916 15.8392 12.2363 9.21147 17.4618 6.2614ZM19.7656 11.8464L17.3705 12.5143L17.7198 13.7806C17.7504 13.7715 18.5887 13.5215 18.5822 13.5405C19.0637 13.4077 19.2977 13.643 19.4092 13.871L20.8774 19.2055C20.8975 19.3618 20.8744 19.628 20.5387 19.7219C20.5322 19.7366 19.6959 19.9552 19.6744 19.9609L19.8281 21.4429L22.2254 20.7849L22.7687 22.7547L23.9556 22.4256L23.4199 20.4774C23.7472 20.3931 24.0639 20.3083 24.3717 20.2226L24.9048 22.1623L26.0938 21.8331L25.5537 19.8671C27.5208 19.1982 28.782 18.3079 28.4402 16.3885C28.108 15.1082 27.2689 14.3679 26.0598 14.4106C26.6533 13.8696 26.9149 13.1331 26.5317 12.1336C26.0096 10.7675 24.6641 10.6338 23.0929 10.9247L22.5563 8.97693L21.3678 9.30695L21.8899 11.2034C21.578 11.2899 21.2597 11.3835 20.9439 11.4784L20.4185 9.57028L19.2304 9.89897L19.7656 11.8464ZM22.3358 16.4253C23.1424 16.2018 25.6052 15.2714 26.0281 16.8059C26.4331 18.2771 23.8602 18.8104 23.0539 19.0344L22.3358 16.4253ZM21.3552 12.8645C22.0272 12.6786 24.0764 11.8825 24.4614 13.2776C24.8288 14.6154 22.6788 15.0447 22.0073 15.2315L21.3552 12.8645Z"
      fill="#8FC258"
    />
  </svg>
);

export { BitcoinCashIcon };
